import axios from 'axios';

export const http = axios.create({
    crossDomain: true
})

// Intercept 401 response and redirect to login
http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
    localStorage.clear();
    window.location = window.location.href;
  } else {
    return Promise.reject(error);
  }
});

export const config = {
    baseUrl(disableLocale) {
        let config = window.app.config;
        return config.baseUrl + (disableLocale ? '' : config.locale);
    }
}



// WEBPACK FOOTER //
// ./src/api/__http.js